import { IntranetContentKind } from '@gb-ticket/shared-types';
import { useSearchParams } from 'react-router';

import {
  useIntranetCategories,
  useIntranetContents,
} from '@/products/intranet/features/intranet/use-intranet';

/** Channel list props for sheets and the desktop rail. */
export function useIntranetChannelNav() {
  const categories = useIntranetCategories();
  const [params] = useSearchParams();
  const activeSlug = params.get('category');
  const saved = params.get('saved') === 'true';
  const savedOverview = useIntranetContents({
    kind: IntranetContentKind.NEWS,
    saved: true,
    page: 1,
    pageSize: 1,
  });

  return {
    categories: categories.data?.items ?? [],
    activeSlug,
    saved,
    savedCount: savedOverview.data?.total,
  };
}
